import type {
  DiscoveryFilters,
  NormalizedDiscoveryFilters,
} from "../types/discoveryFilter.types";

export function normalizeDiscoveryFilters(
  filters: DiscoveryFilters = {}
): NormalizedDiscoveryFilters {
  const searchTerm = filters.searchTerm?.trim() || null;
  const platforms = Array.isArray(filters.platforms)
    ? [...filters.platforms].filter(Boolean).sort()
    : [];

  const tier = filters.tier?.trim() || null;
  const location = filters.location?.trim() || null;
  const category = filters.category?.trim() || null;
  const language = filters.language?.trim() || null;
  const gender = filters.gender?.trim() || null;

  const minFollowers =
    typeof filters.minFollowers === "number" && filters.minFollowers > 0
      ? filters.minFollowers
      : null;
  const maxFollowers =
    typeof filters.maxFollowers === "number" && filters.maxFollowers > 0
      ? filters.maxFollowers
      : null;
  const minEngagement =
    typeof filters.minEngagement === "number" && filters.minEngagement > 0
      ? filters.minEngagement
      : null;
  const maxEngagement =
    typeof filters.maxEngagement === "number" && filters.maxEngagement > 0
      ? filters.maxEngagement
      : null;

  const limit =
    typeof filters.limit === "number" && filters.limit > 0 ? filters.limit : 50;
  const offset =
    typeof filters.offset === "number" && filters.offset >= 0
      ? filters.offset
      : 0;

  return {
    searchTerm,
    platforms,
    tier,
    location,
    category,
    language,
    minFollowers,
    maxFollowers,
    minEngagement,
    maxEngagement,
    gender,
    limit,
    offset,
  };
}
